"use strict";

import tablesort from "tablesort";
import "../common/tablesort_numeric";
import "../common/tablesort_time";
import "./frozen-headers";

import renderWeeklyReportHeader from "./render-weekly-report-extended-header";
import renderWeeklyReport from "./render-weekly-report-extended";
import removeInitialViewClass from "../common/remove-initial-view-class";
import renderWeeklyReportCSV from "./render-weekly-viewing-summary-csv";
import fileDownloader from "../common/file-downloader";

export default (dataUrl, options = {}) => sb => {
    let form;
    let selectedPeriod = null;
    let currentData;
    let viewTab;
    let definitionType;

    const renderReport = (data, filter, activeFilter = false) => {
        let report = sb.find("table");
        let body = report.query("tbody");
        let tableHeaders = report.query("#sortable-headers");
        definitionType = sb.find("input[name='definition_selector']:checked")[0].value;
        viewTab = sb.find(".active")[0].getAttribute("data-view-type");

        hidePleaseWait();
        sb.empty(tableHeaders).append(tableHeaders, renderWeeklyReportHeader());
        sb.empty(body).append(body, renderWeeklyReport(data, filter, viewTab, activeFilter));

        if(viewTab) {
            tablesort(report[0]);
        }

        if (definitionType === "ttsv") {
            jQuery(".c7tv").hide();
            jQuery(".ttsv").show();
        } else {
            jQuery(".ttsv").hide();
            jQuery(".c7tv").show();
        }

        report.css("display", "inline-table");
        sb.notify({type: "tableUpdated"});

        removeInitialViewClass(sb);
    };

    const downloadCSV = data => {
        let viewType = sb.find(".active")[0].getAttribute("data-view-type");
        let activeFilter = filter.value != '';
        let definitionType = sb.find("input[name='definition_selector']:checked")[0].value;

        fileDownloader(
            renderWeeklyReportCSV(data, {
                showTotal: 1,
                filter: filter,
                view_type: viewType,
                activeFilter: activeFilter,
                definition_type: definitionType
            }),
            'Weekly-Viewing-Summary-Report.csv',
            'text/csv;charset=utf-8'
        );
    };

    const onClickDownloadCSV = () => {
        let viewType = sb.find(".active")[0].getAttribute("data-view-type");
        let definitionType = sb.find("input[name='definition_selector']:checked")[0].value;
        let sortColumn = '';
        let sortOrder = '';

        sb.find("#datatable th.sort-header").forEach(function (element) {
            if (element.classList.contains('sort-down') || element.classList.contains('sort-up')) {
                sortColumn = element.cellIndex;
                sortOrder = element.classList.contains('sort-up') ? 'asc' : 'desc';
            }
        });

        if (options.periodIdField !== undefined) {
            selectedPeriod = jQuery("#" + options.periodIdField).val();
        }

        const postData = {
            method: "POST",
            period: selectedPeriod,
            view_type: viewType,
            sort_column: sortColumn,
            sort_order: sortOrder,
            definition_type: definitionType
        };
        showPleaseWait();
        sb.postApi(dataUrl, postData)
            .then(downloadCSV)
            .then(hidePleaseWait);
    };

    const showPleaseWait = () => {
        let wait = sb.find("div.scroll_datagrid .wait");
        wait.css("display", "block");
    };

    const hidePleaseWait = () => {
        let wait = sb.find("div.scroll_datagrid .wait");
        wait.css("display", "none");
    };

    const onFormSubmit = e => {
        let viewType = sb.find(".active")[0].getAttribute("data-view-type");
        let definitionType = sb.find("input[name='definition_selector']:checked")[0].value;

        if (options.periodIdField !== undefined) {
            selectedPeriod = jQuery("#" + options.periodIdField).val();
        }

        e.preventDefault();

        showPleaseWait();
        sb.postApi(dataUrl, {
            method: "POST",
            period: selectedPeriod,
            view_type: viewType,
            definition_type: definitionType
        }).then(
            data => {
                currentData = data;
                return renderReport(currentData);
            }
        );
    };

    const onViewChange = (elem) => {
        let selectedView = elem.currentTarget.getAttribute("data-view-type");
        let definitionType = sb.find("input[name='definition_selector']:checked")[0].value;
        let tableFootNote = sb.find("#wws-new-table-footnote")[0];
        let table = sb.find("table.datagrid");
        let subSelectedView = sb.find(".btn-report-type.active")[0];
        viewTab = sb.find(".btn-report-type");
        table.css("display", "none");

        if (selectedView === null) {
            table.removeClass("sortable");
        } else {
            table.addClass("sortable");
        }

        if (elem.currentTarget.tagName.toLowerCase() !== 'input') {
            viewTab.forEach(btn => {
                btn.classList.remove("active");
            });

            elem.currentTarget.classList.toggle("active");
        }

        tableFootNote.style.display = selectedView === "by_broadcaster" || subSelectedView === "by_broadcaster"
            ? "none"
            : "block";

        if (options.periodIdField !== undefined) {
            selectedPeriod = jQuery("#" + options.periodIdField).val();
        }

        showPleaseWait();
        sb.postApi(dataUrl, {
            method: "POST",
            period: selectedPeriod,
            view_type: selectedView,
            definition_type: definitionType
        }).then(
            data => {
                currentData = data;
                return renderReport(currentData);
            }
        );
    };

    return {
        init() {
            form = sb.find("form");
            viewTab = sb.find(".btn-report-type");
            definitionType = sb.find(".definition-selector");

            sb.addEvent(sb.find("#button_download_trigger"), "click", onClickDownloadCSV);
            sb.addEvent(form, "submit", onFormSubmit);
            viewTab.forEach(elem => {
                sb.addEvent(elem, "click", onViewChange);
            });

            definitionType.forEach(elem => {
                sb.addEvent(elem, "click", onViewChange);
            });

            if (options.periodIdField === undefined) {
                sb.find("#button_submit")[0].click();
            }

            sb.listen({
                periodsSelectionChanged: period => selectedPeriod = period,
                tableFilter: filter => {
                    if (currentData) {
                        renderReport(currentData, filter, filter.length > 0);
                    }
                }
            });
        },
        destroy() {
            sb.ignore(["periodsSelectionChanged", "tableFilter"]);

            sb.removeEvent(form, "submit", onFormSubmit);
            sb.removeEvent(sb.find("#button_download_trigger"), "click", onClickDownloadCSV);

            form = null;
        }
    }
};

